/**
 * MobileSearch
 */
import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { Transition } from 'react-transition-group';
import { useUuid } from 'ui-component-library/hooks';
import { Icon } from 'ui-component-library/base';
/** A search component for phones. */
var MobileSearch = function (_a) {
    var SearchField = _a.SearchField, SearchResult = _a.SearchResult, openSearchPane = _a.openSearchPane, closeSearchPane = _a.closeSearchPane, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b;
    var getUuid = useUuid()[0];
    var _c = useState(isOpen), expanded = _c[0], setExpanded = _c[1];
    var id = getUuid();
    var fieldWrapperRef = useRef(null);
    var onOpen = function () {
        setExpanded(true);
    };
    useEffect(function () {
        if (expanded && SearchResult) {
            document.body.classList.add('searchfield-active');
        }
        return function () {
            document.body.classList.remove('searchfield-active');
        };
    }, [expanded, SearchResult]);
    useEffect(function () {
        if (isOpen) {
            setExpanded(true);
        }
        else {
            setExpanded(false);
        }
    }, [isOpen]);
    useEffect(function () {
        if (expanded) {
            setTimeout(function () {
                fieldWrapperRef.current.querySelector('input').focus();
            }, 300);
        }
    }, [expanded, fieldWrapperRef]);
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", "aria-controls": "mobile-search-" + id, "aria-expanded": expanded, "aria-label": openSearchPane, onClick: onOpen, "data-cid": "MobileSearch" },
            React.createElement(Icon, { icon: "search", size: 2, "aria-hidden": true, className: "text-black" })),
        React.createElement(Transition, { in: expanded, timeout: 400 }, function (state) { return (React.createElement("div", { id: "mobile-search-" + id, className: clsx('absolute top-0 left-0 w-full min-h-full overflow-y-scroll z-50', SearchResult ? 'bg-white' : 'page-overlay', state === 'exiting' ? 'animate-fade-out' : 'animate-fade-in'), hidden: state === 'exited' },
            React.createElement("div", { ref: fieldWrapperRef, className: "flex p-4 bg-white mobilesearch__searchfield-wrapper" },
                SearchField,
                React.createElement("button", { type: "button", className: "mx-4", "aria-controls": "mobile-search-" + id, "aria-expanded": expanded, "aria-label": closeSearchPane, onClick: function () { return setExpanded(!expanded); } },
                    React.createElement(Icon, { icon: "close", size: 2, "aria-hidden": true, className: "text-teal" }))),
            SearchResult && (React.createElement("div", { className: "px-4 pb-4 bg-white" }, SearchResult)))); })));
};
export default MobileSearch;
